export const getContainerFactoryStyles = () =>
  ({
    Container: {
      display: 'flex',
      margin: '2px 0 2px 0',
      '& .is-disabled': {
        border: '1px solid rgb(179, 176, 173)',
        borderRadius: '2px',
      },
      '& .ms-Dropdown-title': {
        borderRadius: '2px',
      },
      '& .ms-TextField .ms-TextField-fieldGroup': {
        borderRadius: '2px',
      },
    },
    OperandContainer: {
      width: '186px',
    },
    OperatorContainer: {
      '& span.defaultOperator': {
        display: 'block',
        lineHeight: '32px',
        padding: '0 39px',
      },
    },
    OperandValueContainer: {
      width: '186px',
      maxHeight: '80px',
      height: '100%',
    },
    TextArea: {
      maxHeight: 80,
      overflow: 'hidden scroll',
      '&::-webkit-scrollbar': {
        width: 4,
        backgroundColor: 'transparent',
      },

      '&::-webkit-scrollbar-thumb': {
        width: 4,
        height: 44,
        backgroundColor: '#EBEAE8',
      },
    },
    DeleteButtonContainer: {
      outline: 'none',
      '& .close': {
        outline: 'none',
        display: 'block',
        position: 'relative',
        width: '14px',
        height: '100%',
        opacity: '1',
        left: '12px',
        '&:hover': {
          opacity: '0.5',
          cursor: 'pointer',
        },
        '&::before, &::after': {
          position: 'absolute',
          left: '6px',
          top: '9px',
          content: '" "',
          height: '14px',
          width: '1px',
          backgroundColor: 'rgb(96, 94, 92)',
        },
        '&::before': {
          transform: 'rotate(45deg)',
        },
        '&::after': {
          transform: 'rotate(-45deg)',
        },
      },
    },
  });
